<template>
  <div class="invest-general">
    <div class="invest-general-container">
      <h1>
        AI, Predictive Pricing And Merchandising Data <br>
        <strong>Saving Dealers Hundreds Of Millions Of Dollars!</strong>
      </h1>
      <h2>
        How OOYYO is Increasing Valuation?
      </h2>
      <h3>
        <strong>OOYYO</strong> use <strong>AI</strong> and <strong>Big Data</strong> information:
      </h3>
      <div class="invest-general-grid">
        <div>
          <ul>
            <li>
              In used-car retailing every day counts because every car
              represents both a <strong>big investment and an opportunity cost.</strong> Having
              this insight is key to maximizing inventory turn and thus profits.
            </li>

            <li>
              After crunching mounds of data, <strong>OOYYO shows how price changes</strong> can
              affect how long a vehicle stays in inventory
            </li>

            <li>
              Car sellers can use <strong>OOYYO DATA to buy</strong>, sell, and merchandise
              inventory accurately and effectively.
            </li>
          </ul>
        </div>
        <div>
          <img
            src="@/images/invest/invest-big-data-crop.jpg"
            class="rounded-3 border shadow-lg d-block mx-lg-auto img-fluid"
            loading="lazy"
          />
        </div>
        <div>
          <img
            src="@/images/invest/ai1.jpg"
            class="rounded-3 border shadow-lg d-block mx-lg-auto img-fluid"
            loading="lazy"
          />
        </div>
        <div>
          <ul>
            <li>
              <strong>Combined with OOYYO AI-powered analytics</strong>, this level of automotive
              data and insights is not available anywhere else in <strong>the European
              market!</strong>
            </li>
            <li>
              OOYYO can set up many other predictive models and <strong>save hundreds of
              millions of dollars</strong> in large car operations expenses.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
